(() => {
  const configNode = document.getElementById('TbbFestiveConfig');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const root = config.root.endsWith('/') ? config.root : `${config.root}/`;
  const nativeFetch = window.fetch.bind(window);
  const giftKey = '_tbb_diwali_gift';
  const isPrivate = /\/pages\/[^/]*cred/i.test(location.pathname);
  let queue = Promise.resolve();
  let timer;
  let saving;
  let checkoutPending = false;
  const checkoutPass = new WeakSet();
  let blockedSignature = '';
  let lastAutoGift = false;
  let declinedSignature = '';
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {style: 'currency', currency: 'INR', maximumFractionDigits: 0}).format(value / 100);
  const text = (key, value = '') => String(config.strings[key] || '').replace('{amount}', value);
  const getCart = () => nativeFetch(`${root}cart.js`, {credentials: 'same-origin', cache: 'no-store'}).then(response => {
    if (!response.ok) throw new Error(text('cartError'));
    return response.json();
  });
  async function post(path, body) {
    const response = await nativeFetch(`${root}cart/${path}.js`, {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify(body)});
    const result = await response.json();
    if (!response.ok || result.status >= 400) throw new Error(result.description || text('cartError'));
    return result;
  }
  function serialize(work) {
    const task = queue.then(work);
    queue = task.catch(() => {});
    return task;
  }
  function refresh(cart) {
    document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
    document.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart, tbb: true}}));
    document.querySelectorAll('[data-cart-count]').forEach(node => {
      node.textContent = String(cart.item_count);
      node.setAttribute('data-cart-count', String(cart.item_count));
    });
  }
  function subtotal(cart) {
    return cart.items.filter(item => item.variant_id !== config.giftVariant && !item.gift_card).reduce((sum, item) => sum + item.final_line_price, 0);
  }
  function signature(cart) {
    return `${cart.currency}:${subtotal(cart)}:${cart.items.filter(item => item.variant_id !== config.giftVariant).map(item => `${item.key}:${item.quantity}:${item.final_line_price}`).join('|')}`;
  }
  function renderStatus(cart, status = '') {
    const amount = subtotal(cart);
    const freeGift = cart.items.some(item => item.variant_id === config.giftVariant && item.final_line_price === 0);
    const sig = signature(cart);
    document.querySelectorAll('[data-tbb-gift-progress]').forEach(node => {
      node.hidden = isPrivate || !config.giftEnabled || cart.currency !== 'INR';
      const output = node.querySelector('[data-tbb-gift-status]');
      if (output) output.textContent = status || (freeGift ? text('giftAdded') : amount < config.threshold ? text('giftRemaining', money(config.threshold - amount)) : declinedSignature === sig ? text('giftDeclined') : blockedSignature === sig ? text('giftUnavailable') : text('giftChecking'));
      const meter = node.querySelector('progress');
      if (meter) meter.value = Math.min(amount, config.threshold);
    });
  }
  async function reconcile() {
    let cart = await getCart();
    let auto = cart.items.filter(item => item.variant_id === config.giftVariant && item.properties?.[giftKey] === '2026');
    const sig = signature(cart);
    if (!isPrivate && lastAutoGift && auto.length === 0) declinedSignature = sig;
    const eligible = config.giftEnabled && !isPrivate && cart.currency === 'INR' && subtotal(cart) >= config.threshold;
    let changed = false;
    if (eligible && auto.reduce((sum, item) => sum + item.quantity, 0) > 1) {
      await post('update', {updates: Object.fromEntries(auto.map((item, index) => [item.key, index === 0 ? 1 : 0]))});
      cart = await getCart();
      auto = cart.items.filter(item => item.variant_id === config.giftVariant && item.properties?.[giftKey] === '2026');
      changed = true;
    }
    if (auto.length && (!eligible || auto.some(item => item.final_line_price > 0))) {
      await post('update', {updates: Object.fromEntries(auto.map(item => [item.key, 0]))});
      cart = await getCart();
      changed = true;
      if (eligible && auto.some(item => item.final_line_price > 0)) blockedSignature = sig;
    }
    const samplerAlreadyPresent = cart.items.some(item => item.variant_id === config.giftVariant);
    if (eligible && !samplerAlreadyPresent && blockedSignature !== sig && declinedSignature !== sig) {
      try {
        await post('add', {items: [{id: config.giftVariant, quantity: 1, properties: {[giftKey]: '2026'}}]});
        cart = await getCart();
        const added = cart.items.find(item => item.variant_id === config.giftVariant && item.properties?.[giftKey] === '2026');
        if (added && added.final_line_price !== 0) {
          await post('change', {id: added.key, quantity: 0});
          cart = await getCart();
          blockedSignature = signature(cart);
        }
        changed = true;
      } catch (error) {
        blockedSignature = sig;
      }
    }
    lastAutoGift = cart.items.some(item => item.variant_id === config.giftVariant && item.properties?.[giftKey] === '2026');
    renderStatus(cart);
    if (changed) refresh(cart);
    return cart;
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(() => serialize(reconcile).catch(() => {}), 200);
  }
  document.addEventListener('cart:updated', event => {
    if (event.detail?.tbb) return;
    schedule();
  });
  document.addEventListener('quick-cart:open', schedule);
  document.addEventListener('cart:item-added', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
  document.addEventListener('input', event => {
    if (!event.target.matches('[data-tbb-cart-message]')) return;
    clearTimeout(saving);
    const value = event.target.value.slice(0, 240);
    document.querySelectorAll('[data-tbb-cart-message]').forEach(node => { if (node !== event.target) node.value = value; });
    document.querySelectorAll('[data-tbb-message-status]').forEach(node => { node.textContent = text('messageSaving'); });
    saving = setTimeout(() => saveMessage(value), 350);
  });
  function saveMessage(value) {
    return serialize(async () => {
      try {
        await post('update', {attributes: {'Gift message': value}});
        document.querySelectorAll('[data-tbb-message-status]').forEach(node => { node.textContent = text('messageSaved'); });
        return true;
      } catch (error) {
        document.querySelectorAll('[data-tbb-message-status]').forEach(node => { node.textContent = text('messageError'); });
        return false;
      }
    });
  }
  document.addEventListener('click', async event => {
    const target = event.target.closest('.shiprocket-headless[data-type="cart"],.shiprocket-headless[data-type="product"],button[name="checkout"]');
    if (!target) return;
    const control = event.target.closest('button,input,a,.sr-headless-checkout') || target;
    if (checkoutPass.has(control)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutPending) return;
    checkoutPending = true;
    control.setAttribute('aria-busy', 'true');
    try {
      clearTimeout(saving);
      const isProductCheckout = target.matches('.shiprocket-headless[data-type="product"]');
      const field = target.closest('form,.quick-cart,.cart')?.querySelector(isProductCheckout ? '[data-tbb-product-message]' : '[data-tbb-cart-message]');
      if (isProductCheckout && field) {
        const nativeGiftNote = target.closest('form')?.querySelector('[data-tbb-native-gift-note]');
        if (nativeGiftNote) nativeGiftNote.value = field.value.slice(0, 240);
      }
      if (field && !(await saveMessage(field.value.slice(0, 240)))) return;
      await serialize(reconcile);
      checkoutPass.add(control);
      control.click();
      setTimeout(() => checkoutPass.delete(control), 1000);
    } catch (error) {
      document.querySelectorAll('[data-tbb-gift-status]').forEach(node => { node.textContent = text('cartError'); });
    } finally {
      control.removeAttribute('aria-busy');
      checkoutPending = false;
    }
  }, true);
  document.addEventListener('change', event => {
    if (event.target.matches('[data-tbb-product-message]')) {
      const value = event.target.value.slice(0, 240);
      clearTimeout(saving);
      saveMessage(value);
    }
  });
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-tbb-add-set]');
    if (!button || button.disabled) return;
    const status = button.closest('.tbb-set').querySelector('[data-set-status]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = text('setAdding');
    try {
      await serialize(async () => {
        const selected = JSON.parse(button.dataset.setItems);
        const items = selected.map(item => ({id: item.id, quantity: item.quantity, properties: {'Gift set': button.dataset.setTitle}}));
        await post('add', {items});
      });
      await serialize(reconcile);
      location.assign(`${root}cart`);
    } catch (error) {
      status.textContent = error.message;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
  document.addEventListener('input', event => {
    const bulk = event.target.closest('[data-tbb-concierge]');
    if (!bulk) return;
    const value = selector => bulk.querySelector(selector)?.value.trim() || '';
    const fields = [['Boxes', value('[data-bulk-quantity]')], ['Budget per box (INR)', value('[data-bulk-budget]')], ['Delivery city/cities', value('[data-bulk-city]')], ['Required date', value('[data-bulk-date]')]].filter(([, val]) => val).map(([label, val]) => `${label}: ${val}`);
    const message = [text('bulkMessage'), ...fields, location.origin + location.pathname].join('\n');
    bulk.querySelector('[data-bulk-whatsapp]').href = `https://wa.me/918100662518?text=${encodeURIComponent(message)}`;
  });
  const observer = new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('[data-tbb-cart-gifting]') || node.querySelector?.('[data-tbb-cart-gifting]'))))) schedule();
  });
  observer.observe(document.body, {childList: true, subtree: true});
  window.TbbFestive = {ready: () => serialize(reconcile), saveMessage};
  schedule();
})();
